// @flow
import React from "react"

import DebugTools from "./DebugTools"
import Splitster from "./Splitster"
import ChangeAPI from "./ChangeAPI"
import OtherDebugInfo from "./OtherDebugInfo"
import SwitchButtons from "common/components/SwitchButtons/SwitchButtons"

const SWITCH_BUTTONS_OPTIONS = [
  {
    key: "tools",
    name: "Tools",
  },
  {
    key: "splitster",
    name: "Splitster",
  },
  {
    key: "other",
    name: "Other",
  },
  {
    key: "changeAPI",
    name: "Change API",
  },
]

type Props = {}

type State = {|
  tab: string,
|}

export default class DebugModal extends React.Component<Props, State> {
  state = {
    tab: "tools",
  }

  handleSwitchButtonsChange = (tab: string) => {
    this.setState({ tab })
  }

  render() {
    const { tab } = this.state

    return (
      <div className="DebugModal">
        <SwitchButtons
          onChange={this.handleSwitchButtonsChange}
          fullwidth
          options={SWITCH_BUTTONS_OPTIONS}
          active={tab}
        />

        {tab === "tools" && <DebugTools />}
        {tab === "splitster" && <Splitster />}
        {tab === "changeAPI" && <ChangeAPI />}
        {tab === "other" && <OtherDebugInfo />}
      </div>
    )
  }
}
